import styled from 'styled-components';

export const StyledImageContainer = styled.div`
    height: 140px;
`;
